(() => {
  const init = root => {
    if (!root || root.dataset.editorialReady) return;
    root.dataset.editorialReady = 'true';
    const dialog = root.querySelector('.maul-youtube-dialog');
    let opener;
    root.querySelectorAll('[data-maul-youtube]').forEach(link => {
      link.addEventListener('click', event => {
        const id = link.dataset.maulYoutube;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || !/^[\w-]{11}$/.test(id) || !dialog?.showModal) return;
        event.preventDefault();
        opener = link;
        dialog.querySelector('.maul-youtube-head p').textContent = link.dataset.title;
        dialog.querySelector('[data-maul-youtube-external]').href = link.href;
        const frame = document.createElement('iframe');
        frame.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0&playsinline=1&start=${Math.max(0, Number(link.dataset.start) || 0)}`;
        frame.title = link.dataset.title;
        frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        frame.allowFullscreen = true;
        frame.referrerPolicy = 'strict-origin-when-cross-origin';
        dialog.querySelector('.maul-youtube-player').replaceChildren(frame);
        dialog.showModal();
      });
    });
    if (dialog) {
      dialog.querySelector('[data-maul-youtube-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const r = dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => {
        dialog.querySelector('.maul-youtube-player').replaceChildren();
        opener?.focus({preventScroll:true});
      });
    }
    const reviews = root.querySelector('#judgeme_product_reviews');
    if (!reviews) return;
    const enhanceReviews = () => {
      // Keep the app's live content and interactions; only reorganize presentation.
      const histogram = reviews.querySelector('.jdgm-histogram');
      const row = reviews.querySelector('.jdgm-row-stars');
      if (histogram && row && !histogram.closest('.maul-rating-breakdown')) {
        const disclosure = document.createElement('details');
        disclosure.className = 'maul-rating-breakdown';
        const summary = document.createElement('summary');
        summary.textContent = 'Rating breakdown';
        disclosure.append(summary, histogram);
        row.after(disclosure);
      }
      reviews.querySelectorAll('.jdgm-rev__body:not([data-maul-copy])').forEach(body => {
        body.dataset.maulCopy = 'true';
        if ((body.textContent || '').trim().length < 300) return;
        body.classList.add('maul-review-copy-collapsed');
        body.id ||= `maul-review-copy-${++init.copyIndex}`;
        const toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'maul-review-read-more';
        toggle.textContent = 'Read full review';
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-controls', body.id);
        toggle.addEventListener('click', () => {
          const open = toggle.getAttribute('aria-expanded') !== 'true';
          toggle.setAttribute('aria-expanded', String(open));
          body.classList.toggle('maul-review-copy-collapsed', !open);
          toggle.textContent = open ? 'Show less' : 'Read full review';
        });
        body.after(toggle);
      });
      reviews.querySelectorAll('.jdgm-rev__reply:not([data-maul-reply])').forEach(reply => {
        reply.dataset.maulReply = 'true';
        const disclosure = document.createElement('details');
        disclosure.className = 'maul-review-response';
        const summary = document.createElement('summary');
        summary.textContent = 'NSABERS response';
        const container = document.createElement('div');
        while (reply.firstChild) container.append(reply.firstChild);
        disclosure.append(summary, container);
        reply.append(disclosure);
      });
    };
    enhanceReviews();
    let scheduled = false;
    const observer = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => { scheduled = false; enhanceReviews(); });
    });
    observer.observe(reviews, {childList:true, subtree:true});
    root.addEventListener('maul:editorial-cleanup', () => {
      observer.disconnect();
      if (dialog?.open) dialog.close();
    }, {once:true});
  };
  init.copyIndex = 0;
  document.querySelectorAll('[data-ns-maul-collector]').forEach(init);
  document.addEventListener('shopify:section:load', event => init(event.target.querySelector('[data-ns-maul-collector]')));
  document.addEventListener('shopify:section:unload', event => event.target.querySelector('[data-ns-maul-collector]')?.dispatchEvent(new Event('maul:editorial-cleanup')));
})();
